import Inputmask from 'inputmask';

export function useAppendMask($element: HTMLInputElement): void {
	const mask: string = $element.dataset.mask;

	switch (mask) {
		case 'date':
			Inputmask('datetime', {
				placeholder: '__.__.____',
				inputFormat: 'dd.mm.yyyy',
			}).mask($element);
			break;

		case 'datetime':
			Inputmask('datetime', {
				placeholder: '__.__.____ __:__',
				inputFormat: 'dd.mm.yyyy HH:MM',
			}).mask($element);
			break;

		case 'tel':
			Inputmask({
				mask: '+7 (999) 999-99-99',
			}).mask($element);
			break;

		case 'postal-code':
			Inputmask({
				mask: '999999',
			}).mask($element);
			break;

		case 'inn':
			Inputmask({
				mask: ['9999999999', '999999999999'],
			}).mask($element);
			break;

		case 'price':
			Inputmask({
				alias: 'numeric',
				groupSeparator: ' ',
				autoGroup: true,
				digits: 0,
				placeholder: '',
				showMaskOnHover: false,
				stripLeadingZeroes: false,
				rightAlign: false,
				allowMinus: false,
			}).mask($element);
			break;

		default:
			Inputmask({
				mask: mask,
			}).mask($element);
			break;
	}
}
